import DomToImage from "dom-to-image";
import { Document, Image, Page, pdf } from "@react-pdf/renderer";
import { useCallback, useState } from "react";
import { downloadBlob } from "../../../../../functions/utilFunctions";
import {
  Button,
  Group,
  Loader,
  LoadingOverlay,
  Modal,
  Stack,
  Text,
} from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import CampaignsListing from "../CampaignsListing";

const ExportCampaignTable = () => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const [opened, setOpened] = useState(false);

  const handleOpen = () => {
    setOpened(true);
    setLoading(false);
  };

  const handleClose = () => {
    setOpened(false);
    setLoading(false);
  };

  const handleExport = useCallback(async () => {
    setLoading(true);
    let blobs = [];
    let requests = [];

    requests.push(
      new Promise((resolve, reject) => {
        DomToImage.toBlob(document.getElementById("export-table")).then(
          (blob) => {
            blobs.push(blob);

            resolve(blob);
          }
        );
      })
    );

    Promise.allSettled(requests).then((res) => {
      let newDocumentBlobs = res.map((x) => x.value);
      const Doc = (
        <Document>
          {newDocumentBlobs.map((item, i) => (
            <Page key={i}>{item && <Image source={item} />}</Page>
          ))}
        </Document>
      );

      pdf(Doc)
        .toBlob()
        .then((b) => {
          downloadBlob(b, "Stats - export");
        })
        .finally(() => {
          setLoading(false);
        });
    });
  }, []);

  return (
    <>
      <Button
        onClick={handleOpen}
        leftSection={<IconDownload size={18} />}
        color="tertiary.8"
        variant="subtle"
        justify="start"
        loading={loading}
      >
        {lang.contact_lists.export_contacts.label} PDF
      </Button>

      <Modal
        title={lang.reports.export_title}
        opened={opened}
        onClose={handleClose}
        size={"100%"}
      >
        <LoadingOverlay
          visible={loading}
          pos={"sticky"}
          top={0}
          w={"100%"}
          h={"85vh"}
          overlayProps={{ blur: 2 }}
          loaderProps={{
            children: (
              <Stack align="center">
                <Loader />

                <Text size="xl">{lang.reports.generating}</Text>
              </Stack>
            ),
          }}
        />
        <Stack className="campaigns-page" id="export-table" gap={"xl"} h={"230vh"}>
          <CampaignsListing isExport />
        </Stack>

        <Group
          justify="end"
          gap={"xl"}
          py={16}
          pos={"sticky"}
          bottom={-1}
          bg={"#fff"}
          style={{ zIndex: 110 }}
          wrap="nowrap"
        >
          <Button
            leftSection={<IconDownload size={20} />}
            size="lg"
            onClick={handleExport}
            disabled={loading}
          >
            {loading ? lang.reports.please_wait : lang.reports.download_label}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default ExportCampaignTable;
